import { KeyStrokeTree } from './types.ts';

export const Key = {
  // --- Letters (Alphabet) ---
  KeyA: { code: 'KeyA', keyboardKey: 'A' },
  KeyB: { code: 'KeyB', keyboardKey: 'B' },
  KeyC: { code: 'KeyC', keyboardKey: 'C' },
  KeyD: { code: 'KeyD', keyboardKey: 'D' },
  KeyE: { code: 'KeyE', keyboardKey: 'E' },
  KeyF: { code: 'KeyF', keyboardKey: 'F' },
  KeyG: { code: 'KeyG', keyboardKey: 'G' },
  KeyH: { code: 'KeyH', keyboardKey: 'H' },
  KeyI: { code: 'KeyI', keyboardKey: 'I' },
  KeyJ: { code: 'KeyJ', keyboardKey: 'J' },
  KeyK: { code: 'KeyK', keyboardKey: 'K' },
  KeyL: { code: 'KeyL', keyboardKey: 'L' },
  KeyM: { code: 'KeyM', keyboardKey: 'M' },
  KeyN: { code: 'KeyN', keyboardKey: 'N' },
  KeyO: { code: 'KeyO', keyboardKey: 'O' },
  KeyP: { code: 'KeyP', keyboardKey: 'P' },
  KeyQ: { code: 'KeyQ', keyboardKey: 'Q' },
  KeyR: { code: 'KeyR', keyboardKey: 'R' },
  KeyS: { code: 'KeyS', keyboardKey: 'S' },
  KeyT: { code: 'KeyT', keyboardKey: 'T' },
  KeyU: { code: 'KeyU', keyboardKey: 'U' },
  KeyV: { code: 'KeyV', keyboardKey: 'V' },
  KeyW: { code: 'KeyW', keyboardKey: 'W' },
  KeyX: { code: 'KeyX', keyboardKey: 'X' },
  KeyY: { code: 'KeyY', keyboardKey: 'Y' },
  KeyZ: { code: 'KeyZ', keyboardKey: 'Z' },

  // --- Numbers (Top Row) ---
  digit: {
    Digit1: { code: 'Digit1', keyboardKey: '1' },
    Digit2: { code: 'Digit2', keyboardKey: '2' },
    Digit3: { code: 'Digit3', keyboardKey: '3' },
    Digit4: { code: 'Digit4', keyboardKey: '4' },
    Digit5: { code: 'Digit5', keyboardKey: '5' },
    Digit6: { code: 'Digit6', keyboardKey: '6' },
    Digit7: { code: 'Digit7', keyboardKey: '7' },
    Digit8: { code: 'Digit8', keyboardKey: '8' },
    Digit9: { code: 'Digit9', keyboardKey: '9' },
    Digit0: { code: 'Digit0', keyboardKey: '0' },
  },

  // --- Numpad ---
  numpad: {
    Numpad1: { code: 'Numpad1', keyboardKey: '1' },
    Numpad2: { code: 'Numpad2', keyboardKey: '2' },
    Numpad3: { code: 'Numpad3', keyboardKey: '3' },
    Numpad4: { code: 'Numpad4', keyboardKey: '4' },
    Numpad5: { code: 'Numpad5', keyboardKey: '5' },
    Numpad6: { code: 'Numpad6', keyboardKey: '6' },
    Numpad7: { code: 'Numpad7', keyboardKey: '7' },
    Numpad8: { code: 'Numpad8', keyboardKey: '8' },
    Numpad9: { code: 'Numpad9', keyboardKey: '9' },
    Numpad0: { code: 'Numpad0', keyboardKey: '0' },
    NumpadAdd: { code: 'NumpadAdd', keyboardKey: '+' },
    NumpadSubtract: { code: 'NumpadSubtract', keyboardKey: '-' },
    NumpadMultiply: { code: 'NumpadMultiply', keyboardKey: '*' },
    NumpadDivide: { code: 'NumpadDivide', keyboardKey: '/' },
    NumpadDecimal: { code: 'NumpadDecimal', keyboardKey: '.' },
    NumpadEnter: { code: 'NumpadEnter', keyboardKey: 'Enter' },
  },

  // --- Arrow Keys ---
  arrow: {
    ArrowUp: { code: 'ArrowUp', keyboardKey: 'ArrowUp' },
    ArrowDown: { code: 'ArrowDown', keyboardKey: 'ArrowDown' },
    ArrowLeft: { code: 'ArrowLeft', keyboardKey: 'ArrowLeft' },
    ArrowRight: { code: 'ArrowRight', keyboardKey: 'ArrowRight' },
  },

  // --- Modifier Keys ---
  // Generic mappings (Defaults to Left physical key)
  modifier: {
    Shift: { code: 'ShiftLeft', keyboardKey: 'Shift' },
    Control: { code: 'ControlLeft', keyboardKey: 'Control' },
    Alt: { code: 'AltLeft', keyboardKey: 'Alt' },
    Meta: { code: 'MetaLeft', keyboardKey: 'Meta' }, // Windows Key / Mac Command
  },
  // Specific mappings
  modifierSpecific: {
    ShiftLeft: { code: 'ShiftLeft', keyboardKey: 'Shift' },
    ShiftRight: { code: 'ShiftRight', keyboardKey: 'Shift' },
    ControlLeft: { code: 'ControlLeft', keyboardKey: 'Control' },
    ControlRight: { code: 'ControlRight', keyboardKey: 'Control' },
    AltLeft: { code: 'AltLeft', keyboardKey: 'Alt' },
    AltRight: { code: 'AltRight', keyboardKey: 'Alt' },
    MetaLeft: { code: 'MetaLeft', keyboardKey: 'Meta' },
    MetaRight: { code: 'MetaRight', keyboardKey: 'Meta' },
  },

  // --- Navigation & Control ---
  navigation: {
    Enter: { code: 'Enter', keyboardKey: 'Enter' },
    Escape: { code: 'Escape', keyboardKey: 'Escape' },
    Space: { code: 'Space', keyboardKey: ' ' },
    Backspace: { code: 'Backspace', keyboardKey: 'Backspace' },
    Tab: { code: 'Tab', keyboardKey: 'Tab' },
    Delete: { code: 'Delete', keyboardKey: 'Delete' },
    Insert: { code: 'Insert', keyboardKey: 'Insert' },
    Home: { code: 'Home', keyboardKey: 'Home' },
    End: { code: 'End', keyboardKey: 'End' },
    PageUp: { code: 'PageUp', keyboardKey: 'PageUp' },
    PageDown: { code: 'PageDown', keyboardKey: 'PageDown' },
    CapsLock: { code: 'CapsLock', keyboardKey: 'CapsLock' },
    ContextMenu: { code: 'ContextMenu', keyboardKey: 'ContextMenu' },
  },

  // --- Function Keys ---
  functionKey: {
    F1: { code: 'F1', keyboardKey: 'F1' },
    F2: { code: 'F2', keyboardKey: 'F2' },
    F3: { code: 'F3', keyboardKey: 'F3' },
    F4: { code: 'F4', keyboardKey: 'F4' },
    F5: { code: 'F5', keyboardKey: 'F5' },
    F6: { code: 'F6', keyboardKey: 'F6' },
    F7: { code: 'F7', keyboardKey: 'F7' },
    F8: { code: 'F8', keyboardKey: 'F8' },
    F9: { code: 'F9', keyboardKey: 'F9' },
    F10: { code: 'F10', keyboardKey: 'F10' },
    F11: { code: 'F11', keyboardKey: 'F11' },
    F12: { code: 'F12', keyboardKey: 'F12' },
  },

  // --- Symbols & Punctuation (Standard US QWERTY layout) ---
  symbol: {
    Backquote: { code: 'Backquote', keyboardKey: '`' }, // Also tilde (~)
    Minus: { code: 'Minus', keyboardKey: '-' },
    Equal: { code: 'Equal', keyboardKey: '=' },
    BracketLeft: { code: 'BracketLeft', keyboardKey: '[' },
    BracketRight: { code: 'BracketRight', keyboardKey: ']' },
    Backslash: { code: 'Backslash', keyboardKey: '\\' },
    Semicolon: { code: 'Semicolon', keyboardKey: ';' },
    Quote: { code: 'Quote', keyboardKey: "'" },
    Comma: { code: 'Comma', keyboardKey: ',' },
    Period: { code: 'Period', keyboardKey: '.' },
    Slash: { code: 'Slash', keyboardKey: '/' },
  },
} as const satisfies KeyStrokeTree;
